export default __webpack_public_path__ + "static/media/michael.a7ae0e4e.jpg";